import { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";

import "./AddTrainer.css";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db, auth } from "../../firebase/config";
import { getSettings } from "../../services/settingsService";
import { addTrainer, getTrainers } from "../../services/trainerService";

export default function AddTrainer() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    specialization: "",
    salary: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.name.trim()) {
      alert("Please enter Trainer Name");
      return;
    }

    if (!formData.phone.trim()) {
      alert("Please enter Phone Number");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      alert("Please enter a valid 10-digit Phone Number");
      return;
    }

    if (!formData.email.trim()) {
      alert("Please enter Email Address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid Email Address");
      return;
    }

    if (!formData.specialization.trim()) {
      alert("Please enter Specialization");
      return;
    }

    if (!formData.salary) {
      alert("Please enter Monthly Salary");
      return;
    }

    if (Number(formData.salary) <= 0) {
      alert("Salary must be greater than 0");
      return;
    }

    const gym = await getSettings();
    const trainers = await getTrainers();

    if (trainers.length >= gym.features.trainerLimit) {
      alert(
        `Trainer limit reached!\n\nYour ${gym.subscriptionPlan} plan allows only ${gym.features.trainerLimit} trainers.\n\nPlease upgrade your subscription to add more trainers.`,
      );
      return;
    }

    try {
      await addTrainer({
        ...formData,
        status: "Active",
      });

      await updateDoc(doc(db, "gyms", auth.currentUser.uid), {
        totalTrainers: increment(1),
      });
      alert("Trainer Added Successfully");
      navigate("/trainers");

      setFormData({
        name: "",
        phone: "",
        email: "",
        specialization: "",
        salary: "",
      });
    } catch (error) {
      console.error(error);
      alert("Failed to add trainer");
    }
  };

  return (
    <DashboardLayout>
      <div className="add-trainer-page">
        <div className="page-header">
          <div>
            <h1>Add New Trainer</h1>
            <p style={{ fontWeight: "bold", color: "white" }}>
              Register professional trainers and manage your fitness team.
            </p>
          </div>
        </div>

        <div className="trainer-form-container">
          <div className="trainer-form-card">
            <div className="card-header">
              <h2>Trainer Information</h2>
              <span className="badge">Active Status</span>
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>Trainer Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  placeholder="Enter trainer name"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  placeholder="Enter phone number"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  placeholder="Enter email address"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Specialization</label>
                <input
                  type="text"
                  name="specialization"
                  value={formData.specialization}
                  placeholder="Weight Training, Yoga, Cardio..."
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group full-width">
                <label>Monthly Salary (₹)</label>
                <input
                  type="number"
                  name="salary"
                  value={formData.salary}
                  placeholder="Enter monthly salary"
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <button className="save-btn" onClick={handleSubmit}>
              Save Trainer
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
